// src/auth/AuthContext.js
import React, { createContext, useContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import appConfig from '../Config';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const STORAGE_KEY = "auth";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // { id, role }

  useEffect(() => {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      setUser(JSON.parse(raw));
    }
  }, []);

  const signIn = async ({ id, role, password }) => {
    let endpoint = "";
    let payload = {};

    switch (role) {
      case "patient":
        endpoint = appConfig.PATIENT_LOGIN;
        payload = { research_id: id, patient_pw: password };
        break;
      case "attending_physician":
        endpoint = appConfig.AP_LOGIN;
        payload = { user_id: id, password };
        break;
      case "expert_physician":
        endpoint = appConfig.EP_LOGIN;
        payload = { user_id: id, password };
        break;
    }

    try {
      const res = await axios.post(endpoint, payload);
      if (res.status === 200 && res.data.auth_result === "True") {
        const next = { id, role };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
        setUser(next);
        return { ok: true, user: next };
      } else {
        return { ok: false, error: "IDまたはパスワードが正しくありません" };
      }
    } catch (err) {
      console.error("login error:", err);

      if (err.response) {
        if (err.response.status === 422) {
          // FastAPIのバリデーションエラー
          return { ok: false, error: "入力形式が不正です（IDやパスワードを確認してください）" };
        }
        if (err.response.status === 400 || err.response.status === 401) {
          return { ok: false, error: "IDまたはパスワードが正しくありません" };
        }
        return { ok: false, error: `サーバーエラー (${err.response.status})` };
      }

      return { ok: false, error: "サーバーに接続できません" };
    }
  };

  const signOut = () => {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem("patient");
    sessionStorage.removeItem("attending_doctor");
    sessionStorage.removeItem("selected_patient");
    setUser(null);
  };

  const value = useMemo(
    () => ({
      user,
      role: user?.role ?? null,
      isAuthed: !!user,
      signIn,
      signOut,
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
